export default "__VITE_ASSET__Db1wDJBp__"